import * as React from 'react';

import { deleteHonoraryNote, fetchHonoraryNotes } from '../../../../store/details/honorary-note/actions';

import { ConnectedReduxProps, ApplicationState } from '../../../../store';
import { Dispatch } from 'redux';
import HonoraryNoteDetail from './honorary-note-detail';
import HonoraryNoteList from './honorary-note-list';
import { connect } from 'react-redux';
import styles from './honorary-note.module.css';
import { HonoraryNote as HonoraryNoteType } from '../../../../store/details/honorary-note/types';
import { TypeCodeTranslation } from '../../../../business/models/shared.model';


interface PropsFromState {
  readonly selectedHonoraryNote: HonoraryNoteType;
  readonly honoraryNotes: HonoraryNoteType[];
  readonly lineTypeValues: TypeCodeTranslation[];
  readonly unitTypeValues: TypeCodeTranslation[];
  readonly vatPercentageValues: TypeCodeTranslation[];
  readonly currentLanguage: string;
  readonly caseBlocked: boolean;
  readonly instructionId: number;
}
interface PropsFromDispatch {
  readonly getHonoraryNotes: typeof fetchHonoraryNotes;
  readonly deleteHonoraryNote: typeof deleteHonoraryNote;
}

type AllProps = PropsFromState & ConnectedReduxProps & PropsFromDispatch;

class HonoraryNote extends React.Component<AllProps> {

  componentDidMount() {
    this.props.getHonoraryNotes(this.props.instructionId);
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.sideNavContent}>
            <HonoraryNoteDetail {...this.props} key={this.props.selectedHonoraryNote.honoraryNoteId}/>
          </div>
          <div className={styles.sideNav}>
            <div className={styles.remove}
              onClick={() => !this.props.selectedHonoraryNote.locked && !this.props.caseBlocked ? this.props.deleteHonoraryNote(this.props.selectedHonoraryNote.honoraryNoteId) : false}>
              <img alt="" className={styles.img} src={require('../../../../assets/images/remove_85x85.png')} />
            </div>
          </div>
        </div>
        <HonoraryNoteList {...this.props} />
      </div>
    );
  }
}


const mapStateToProps = ({ details: { detailsHonoraryNote }, shared, caseState: { selectedCase } }: ApplicationState) => ({
  honoraryNotes: detailsHonoraryNote.honoraryNotes,
  selectedHonoraryNote: detailsHonoraryNote.selectedHonoraryNote,
  lineTypeValues: detailsHonoraryNote.lineTypeValues,
  vatPercentageValues: detailsHonoraryNote.vatPercentageValues,
  unitTypeValues: detailsHonoraryNote.unitTypeValues,
  currentLanguage: shared.currentLanguage,
  caseBlocked: selectedCase.blocked,
  instructionId: selectedCase.instructionId,
});

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
  deleteHonoraryNote: (honoraryNoteId: number) => dispatch(deleteHonoraryNote(honoraryNoteId)),
  getHonoraryNotes: (instructionId: number) => dispatch(fetchHonoraryNotes(instructionId))
});

export default connect(mapStateToProps, mapDispatchToProps)(HonoraryNote);
